import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, } from '@angular/router';
import firebase from 'firebase';
import { MustMatch } from 'src/app/helpers/must-match.validator';
import { AlertService } from 'src/app/services/alert/alert.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-verify-code',
  templateUrl: './verify-code.page.html',
  styleUrls: ['./verify-code.page.scss'],
})
export class VerifyCodePage implements OnInit {

  verifyCodeForm: FormGroup;
  error;
  obbCode = '';

  constructor(public formBuilder: FormBuilder,
    private authServices: AuthService,
    private activateRoute: ActivatedRoute,
    private alertService: AlertService) {
    this.initConstructor()
  }

  async ngOnInit() {
    this.activateRoute.queryParams.subscribe((param: any) => {
      if(param){
        this.obbCode = param.oobCode
      }
    })
  }

  initConstructor() {
    this.verifyCodeForm = this.formBuilder.group({
      password: ["",
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.,'_~]).{8,}$")
        ])],
      confirmPassword: ["",
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.,'_~]).{8,}$")
        ])]
    }, {
      validator: MustMatch('password', 'confirmPassword')
    });
  }

  get f() {
    return this.verifyCodeForm.controls;
  }

  seePassword(input, icon) {
    input.type = input.type == 'text' ? 'password' : 'text';
    icon.name = icon.name == 'eye-outline' ? 'eye-off-outline' : 'eye-outline';
  }

  recoverAccount() {
    this.error = "";
    firebase.auth().confirmPasswordReset(this.obbCode, this.f.password.value)
      .then(res => {
        this.alertService.presentAlert('Se ha cambiado tu contraseña correctamente. Inicia sesión con tu nueva contraseña');
        this.authServices.logout();
        //this.router.navigateByUrl('login');
      })
      .catch(err => {
        switch (err.code) { 
          case 'auth/expired-action-code':
            this.error = "El código ha expirado"
            break;
          case 'auth/invalid-action-code':
            this.error = "El código es invalido"
            break;
          case 'auth/user-disabled':
            this.error = "El usuario se encuentra desabilitado"
            break;
          case 'auth/user-not-found':
            this.error = "Usuario no encontrado"
            break;
          case 'auth/weak-password':
            this.error = "Contraseña debil"
            break;
          default:
            break;
        }
        console.error(err);
      })
  }

}
